import { BroadcastState } from "./types";

/**
 * Initial state for the Broadcast module.
 * Starts with no broadcasts and no selection.
 */
const state: BroadcastState = {
  broadcastObjects: {},
  broadcastArray: [],
  selectedBroadcastId: "",
  selectedBroadcast: null,
};

export default state;
